import { createAction } from 'redux-actions';
import ParentPass from '../utils/ParentPass/ParentPass'

export const editParentPass = createAction('EDIT_PARENT_PASS', ParentPass.edit);
export const setParentPass = createAction('SET_PARENT_PASS')
export const updateParentPass = createAction('UPDATE_PARENT_PASS',ParentPass.update)
export const updateParentPassImg = createAction('UPDATE_PARENT_PASS_IMG',ParentPass.updateImg)
// export const logoutAction = createAction('UPDATE_APPLICATION_FOR_ADMISSION', AuthDevise.logout);


// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/ParentPassAction.jsx